import React from 'react';
import Helmet from 'react-helmet';
import {
  AGENCY_REGISTRATION_APPLICATION_PAGE,
  HEADER_CONSTANTS,
} from '../utilities/constants';
import { DetailHeader } from '../components/AgencyRegistrationApplicationHeader';
import { MasterPageHeader } from '../components/PageHeader';
import {
  FORM_MODE,
  useAgencyRegistrationApplicationForm,
} from '../components/useAgencyRegistrationApplicationForm';
import AgencyRegistrationApplicationPreview from '../components/AgencyRegistrationApplicationPreview';

const AgencyRegistrationApplicationOriginDetail = props => {
  const {
    formValues,
    downloadFile,
    canEdit,
    canApply,
    handleApply,
    canTemporarySave,
    handleTemporarySave,
    canRemove,
    handleRemove,
    canApplyCancel,
    handleApplyCancel,
    canReapply,
    handleReapply,
    moveEditPage,
    moveDetailPage,
    handleFormClose,
    canDownloadMemorandumFile,
    isDifferent,
  } = useAgencyRegistrationApplicationForm(
    FORM_MODE.ORIGIN_DETAIL,
    props.view.state.id
  );

  return (
    <div className='contruction-slide-view show'>
      <Helmet>
        <title>
          {`${HEADER_CONSTANTS.conference} - ${
            AGENCY_REGISTRATION_APPLICATION_PAGE.ORIGIN_DETAIL.TEXT
          }`}
        </title>
      </Helmet>
      <div className='contruction-slide-view__view'>
        <MasterPageHeader
          title={AGENCY_REGISTRATION_APPLICATION_PAGE.ORIGIN_DETAIL.TEXT}
          onClose={handleFormClose}
        />
        <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
          <div className='contruction-detail-view'>
            <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
              <div className='contruction-detail-view__header'>
                <button className='btn-text--sm' onClick={handleFormClose}>
                  <i className='i-back--blue i-2x vertical-middle' />
                  {AGENCY_REGISTRATION_APPLICATION_PAGE.ORIGINS.TEXT}
                </button>
              </div>
              <DetailHeader
                {...{
                  canEdit,
                  moveEditPage,
                  canApply,
                  handleApply,
                  canTemporarySave,
                  handleTemporarySave,
                  canRemove,
                  handleRemove,
                  canApplyCancel,
                  handleApplyCancel,
                  canReapply,
                  handleReapply,
                }}
              />
              <div className='contruction-detail-view__bar' />
              <div className='contruction-detail-view__main contruction-detail-view__main--fixed contruction-detail-view__main--fix'>
                <AgencyRegistrationApplicationPreview
                  formValues={formValues}
                  downloadFile={downloadFile}
                  moveDetailPage={moveDetailPage}
                  isVisibleOtherAgenciesCount={false}
                  isOrigin={true}
                  canDownloadMemorandumFile={canDownloadMemorandumFile}
                  isDifferent={isDifferent}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgencyRegistrationApplicationOriginDetail;



// WEBPACK FOOTER //
// ./src/pages/AgencyRegistrationApplicationOriginDetail.jsx